export default "__VITE_ASSET__B$Y9yMar__"